import React from 'react';
import styled from 'styled-components';
import { Checkbox } from '@prezi/bento';
import { EIGHT } from '../../../const';
import { ResponsiveModal, InnerScreenGrid, PageWrapper, RowGap, FooterContainer, Button } from '../../../atoms/dumb';
import { useConfig } from '../../../../utils/config';
import { Header } from '../../../molecules/dumb';
import { localI18n } from '../../../../i18n';
const uxCopy = {
  header: localI18n._("Deactivate link"),
  content: localI18n._("This link will be permanently deactivated and the people you\u2019ve shared it with won\u2019t have access to the presentation anymore. Are you sure you want to proceed?"),
  deleteDataCheckbox: localI18n._("Deactivate link and delete data"),
  cancelButton: localI18n._("Cancel"),
  deactivateButton: localI18n._("Deactivate link")
};
const Footer = styled(FooterContainer).withConfig({
  displayName: "DeactivationModal__Footer",
  componentId: "zpzih3-0"
})(["display:flex;flex-direction:row-reverse;column-gap:", "px;"], EIGHT);
const DeactivationModal = ({
  isOpen,
  onClose,
  canDeleteData = false,
  handleDeactivateLink
}) => {
  const [deleteData, setDeleteData] = React.useState(false);
  const {
    modalRootId
  } = useConfig();
  return React.createElement(ResponsiveModal, {
    isOpen: isOpen,
    onClose: onClose,
    hideCloseButton: true,
    rootId: modalRootId
  }, React.createElement(PageWrapper, {
    width: "500px"
  }, React.createElement(InnerScreenGrid, {
    rowGap: RowGap.none
  }, React.createElement(Header, {
    removeBottomBorder: true,
    onBack: onClose
  }, uxCopy.header), canDeleteData ? React.createElement(React.Fragment, null, React.createElement("p", null, uxCopy.content), React.createElement(Checkbox, {
    checked: deleteData,
    onChange: () => setDeleteData(!deleteData)
  }, uxCopy.deleteDataCheckbox)) : uxCopy.content, React.createElement(Footer, null, React.createElement(Button, {
    variant: "danger",
    onClick: () => handleDeactivateLink(canDeleteData && deleteData)
  }, uxCopy.deactivateButton), React.createElement(Button, {
    variant: "transparent",
    onClick: onClose
  }, uxCopy.cancelButton)))));
};
export default DeactivationModal;